import { render, staticRenderFns } from "./discountDetail.vue?vue&type=template&id=4db8bc9d"
import script from "./discountDetail.vue?vue&type=script&lang=js"
export * from "./discountDetail.vue?vue&type=script&lang=js"
import style0 from "./discountDetail.vue?vue&type=style&index=0&id=4db8bc9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports